import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

const state = {
  pager: {
    first: 20,
    after: undefined
  },
  quotes: [],
  activeQuote: {},
  authors: [],
  orders: [
    {
      id: '',
      text: 'Fecha de creación'
    },
    {
      id: '-ranking',
      text: 'Más valorados'
    }
  ],
  changeQuotes: false,
  filterVisibility: false
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: true
})



// WEBPACK FOOTER //
// ./src/vuex/store.js